import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing, Typography } from '@opallabs/gem'

const base: CSSObject = {
  borderRadius: Size.Rounding * 2,
  inlineSize: 180,
  backgroundColor: Color.light.Surface.N000,
}

const searchWrapper: CSSObject = {
  borderBottom: 'solid 1px #e1e4e6',
  padding: '12px 8px',
}

const searchInputContainer: CSSObject = {
  borderRadius: 14,
  blockSize: 24,
  '& input[type=search]': {
    minInlineSize: 90,
  },
}

const listWrapper: CSSObject = {
  padding: '12px 4px 4px 4px',
}

const listTitle: CSSObject = {
  ...Typography.T300,
  paddingLeft: Spacing.S,
  color: Color.light.Text.Default,
}

const list: CSSObject = {
  paddingInlineStart: 0,
  marginBlockStart: Spacing.S,
  marginBlockEnd: 0,
  maxBlockSize: 144,
  minBlockSize: 144,
  overflowY: 'auto',
  'li + li': {
    marginTop: Spacing.XS,
  },
}

const emptySearch: CSSObject = {
  ...Typography.T500,
  padding: '0 4px 8px 4px',
  textAlign: 'center',
  color: Color.light.Text.Gray,
}

const addButton: CSSObject = {
  width: '100%',
}

type CustomChannelColor = {
  [index: string]: string
}

const customChannelColor: CustomChannelColor = {
  blue: '#1aa2c5',
  grey: '#6f7d89',
  orange: '#f7693c',
}

const getChannelColor = (iconName?: string | null): CSSObject => {
  if (!iconName) return {}

  const colorAndIcon = iconName.split(' ')
  const hexColor = customChannelColor[colorAndIcon[0]]

  if (hexColor) {
    return {
      '.menu-option-trailing-icon': { color: hexColor, fill: hexColor },
    }
  }

  return {}
}

export const styles = {
  addButton,
  base,
  emptySearch,
  getChannelColor,
  list,
  listTitle,
  listWrapper,
  searchInputContainer,
  searchWrapper,
}
